import LabelAnnotation from '../models/LabelAnnotation';
import { toothUtils, ARCADA_TOOTH_COUNT } from '@/features/tooth/lib/toothUtils';
import { gConsts } from '@/globals/gConsts';

export default class LabelAnnotationSorter {

    /**
     * 
     * @param {LabelAnnotation} a 
     * @param {LabelAnnotation} b 
     * @returns {number}
     */
    static run(a, b) {
        if (!a || !b)
            return 0;

        return LabelAnnotationSorter._getAnnotationOrderIndex(a) - LabelAnnotationSorter._getAnnotationOrderIndex(b);
    }

    /**
     * 
     * @param {LabelAnnotation} labelAnnotation 
     * @returns {number}
     */
    static _getAnnotationOrderIndex(labelAnnotation) {
        if (!labelAnnotation)
            return 0;

        if ([gConsts.node.report.annotation.types.TOOTH].includes(labelAnnotation.tipo) && labelAnnotation.localizacao?.dentes?.length == 1) {
            const toothDetails = toothUtils.getToothDetailsByLabelId(labelAnnotation.localizacao?.dentes[0]?.id);
            return toothUtils.getToothOrderIndex(toothDetails.numero, 'complete');
        }

        return 0;
    }
}